import { render, staticRenderFns } from "./ShowJurnal.vue?vue&type=template&id=685f06fa&scoped=true&"
import script from "./ShowJurnal.vue?vue&type=script&lang=js&"
export * from "./ShowJurnal.vue?vue&type=script&lang=js&"
import style0 from "./ShowJurnal.vue?vue&type=style&index=0&id=685f06fa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "685f06fa",
  null
  
)

export default component.exports